export const errorMessage:string[] = [
    "I am having some diffuculties chatting right now. Can we chat later?",
    "Hmmmm. Something went wrong! It is probably some problem at my side. I will get it fixed.",
    "This is unusual! I am unable to process this request. Can you please try later? while I get this problem fixed.",
    "I cannot process your request at this time. Sorry for trouble. Please try later."
]